// this method converts price margin value to price markup value > it's primarily used in the item builder
export const convertMarginToMarkup = (number) => {
    if(!number) {return 0;}
    const marginPercent = number / 100;
    const markupPercent = marginPercent / (1 - marginPercent);
    return (markupPercent * 100);
};
